
  function getWidth(el) {
    // this is similar to jquery width()
    return parseFloat(getComputedStyle(el, null).width.replace("px", ""));
  }

  function getHeight(el) {
    return parseFloat(getComputedStyle(el, null).height.replace("px", ""));
  }

  function getOffset(element) {
    // this is similar to jquery offset()
    if (!element.getClientRects().length) {
      return { top: 0, left: 0 };
    }

    let rect = element.getBoundingClientRect();
    let win = element.ownerDocument.defaultView;
    return {
      top: rect.top + win.pageYOffset,
      left: rect.left + win.pageXOffset,
    };
  }

  export {getWidth, getHeight, getOffset}